import { useState } from 'react'

import type { AdUnit } from '@/services/adUnits/adUnitsApi'
import type { LineItem } from '@/services/lineItems/lineItemsApi'
import {
  AdRequestDiagnostics,
  EMPTY_DIAGNOSTIC_FORM,
  type DiagnosticFormValues,
} from './AdRequestDiagnostics'
import { AdUnitMatchingCard } from './AdUnitMatchingCard'
import { DiagnosticLineItemPicker } from './DiagnosticLineItemPicker'

export interface AdUnitAdRequestDiagnosticsProps {
  adUnit: AdUnit
}

/**
 * Tests an ad request on one ad unit, to see which line items would deliver
 * and why the rest would not — optionally narrowed to one line item — under
 * the ad unit's and its site's settings that bear on the answer.
 */
export function AdUnitAdRequestDiagnostics({ adUnit }: AdUnitAdRequestDiagnosticsProps) {
  const [values, setValues] = useState<DiagnosticFormValues>({
    ...EMPTY_DIAGNOSTIC_FORM,
    requestType: 'NORMAL',
  })
  const [lineItem, setLineItem] = useState<LineItem>()

  return (
    <div className="flex flex-col gap-6">
      <AdUnitMatchingCard adUnit={adUnit} />
      <AdRequestDiagnostics
        values={values}
        onChange={(patch) => setValues((current) => ({ ...current, ...patch }))}
        adUnits={[adUnit]}
        lineItemId={lineItem?.id}
        lineItemPicker={<DiagnosticLineItemPicker value={lineItem} onChange={setLineItem} />}
      />
    </div>
  )
}
